import { useEffect, useState } from 'react';
import {
  acceptProviderTermsForUser,
  getAcceptedTermsByUserFromCookies,
  checkZoocasaTermsAreReadInCookies,
  setZoocasaTermsAreReadInCookies,
} from 'utils/compliance';
import { Provider } from '@zoocasa/go-search';

export interface TermsState {
  acceptedBrowserBasedTerms: Provider[];
  acceptedTerms: Provider[];
  acceptTerms: (providerId: Provider) => void;
  areZoocasaTermsRead: boolean;
  setZoocasaTermsStateToRead: () => void;
}

export function useTerms(userId: string | number | undefined): TermsState {
  const [acceptedBrowserBasedTerms, setAcceptedBrowserBasedTerms] = useState<Provider[]>([]);
  const [acceptedTerms, setAcceptedTerms] = useState<Provider[]>([]);
  const [areZoocasaTermsRead, setAreZoocasaTermsRead] = useState(false);

  const refreshTerms = () => {
    const { userBasedTerms, browserBasedTerms } = getAcceptedTermsByUserFromCookies(userId);
    setAcceptedTerms(userBasedTerms);
    setAcceptedBrowserBasedTerms(browserBasedTerms);
  };

  const refreshZoocasaTerms = () => {
    setAreZoocasaTermsRead(checkZoocasaTermsAreReadInCookies());
  };

  useEffect(() => {
    refreshZoocasaTerms();
    refreshTerms();
  }, [userId]); // eslint-disable-line react-hooks/exhaustive-deps

  const acceptTermsFn = (providerId: Provider) => {
    acceptProviderTermsForUser(providerId, userId);
    refreshTerms();
  };

  const setZoocasaTermsStateToRead = () => {
    setZoocasaTermsAreReadInCookies();
    refreshZoocasaTerms();
  };

  return {
    acceptedBrowserBasedTerms,
    acceptedTerms,
    acceptTerms: acceptTermsFn,
    areZoocasaTermsRead,
    setZoocasaTermsStateToRead,
  };
}
